import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiResponse, PagableData } from '../../models/common';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { AuthService } from '../auth/auth.service';
import { MediaInfo, ReqAddImage, ReqAddPlaylist } from '../../models/sign-control/media';

import { StatusEnum } from '../../models/common-enum';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlaylistService {

  domain: string;
  constructor(private http: HttpClient, private authService: AuthService) {
    this.domain = environment.api.domain_sign_control;
  }
  getPlaylist(page?: number, limit?: number, name?: string, ratio?: string, use_type?: number,
    sign_type_id?: number, status?: number, boardsign_id?: number, sign_id?: number, select_type?:number) {
    let params = new HttpParams();
    if (!_.isNil(page)) {
      params = params.append('page', page.toString());
    }
    if (!_.isNil(limit)) {
      params = params.append('limit', limit.toString());
    }
    if (!_.isNil(name)) {
      params = params.append('name', name.toString());
    }
    if (!_.isNil(ratio)) {
      params = params.append('ratio', ratio.toString());
    }
    if (!_.isNil(use_type)) {
      params = params.append('use_type', use_type.toString());
    }
    if (!_.isNil(sign_type_id)) {
      params = params.append('sign_type_id', sign_type_id.toString());
    }
    if (!_.isNil(status)) {
      params = params.append('status', status.toString());
    }
    if (!_.isNil(boardsign_id)) {
      params = params.append('boardsign_id', boardsign_id.toString());
    }
    if (!_.isNil(sign_id)) {
      params = params.append('sign_id', sign_id.toString());
    }
    if (!_.isNil(select_type)) {
      params = params.append('select_type', select_type.toString());
    }
    const uri = `playlist`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      }),
      params: params
    };
    return this.http.get<ApiResponse<PagableData<MediaInfo[]>>>(url, httpOptions);
    // let url = 'assets/data/owner.json';
    // return this.http.get<ApiResponse<PagableData<Owner[]>>>(url);
  }

  getPlaylistRatio() {
    const uri = `playlist/ratio`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.get<ApiResponse<string[]>>(url, httpOptions);
    // let url1 = 'assets/data/ratio.json';
    // return this.http.get<ApiResponse<string[]>>(url1);
  }
  addPlaylist(req?: ReqAddPlaylist) {
    const uri = `playlist`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.post<ApiResponse<any>>(url, req, httpOptions);
  }
  editPlaylist(req: ReqAddPlaylist, id?: number): Observable<ApiResponse<any>> {
    const uri = `playlist/${id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.put<ApiResponse<any>>(url, req, httpOptions);
  }
  deletePlaylist(id: number): Observable<ApiResponse<any>> {
    const uri = `playlist/${id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.delete<ApiResponse<any>>(url, httpOptions);
  }
  deletePlaylistEditStatus(req: ReqAddPlaylist, id?: number): Observable<ApiResponse<any>> {
    req.status = StatusEnum.Delete;
    const uri = `playlist/${id}`;
    const url = `${this.domain}/${uri}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${this.authService.token_type} ${this.authService.user_token}`
      })
    };
    return this.http.put<ApiResponse<any>>(url, req, httpOptions);
  }
}
